import { RtcError } from '../protocol/types.js';
const CALL_FULL_ERRCODE = 'IO_PHONEHQ_CALL_FULL';
const CALL_FULL_REASON = 'call_full';
const codeForStatus = (status) => {
    if (status === 401) {
        return 'unauthorized';
    }
    if (status === 403) {
        return 'forbidden';
    }
    if (status === 429) {
        return 'rate_limited';
    }
    if (status === 400 || status === 404 || status === 409 || status === 422) {
        return 'invalid_request';
    }
    if (status >= 500) {
        return 'unavailable';
    }
    return 'unknown';
};
export const errorFromResponse = async (response, context) => {
    let body = {};
    try {
        const parsed = await response.json();
        if (parsed && typeof parsed === 'object') {
            body = parsed;
        }
    }
    catch {
        body = {};
    }
    const errcode = typeof body.errcode === 'string' ? body.errcode : typeof body.code === 'string' ? body.code : undefined;
    const retryHeader = response.headers?.get('retry-after');
    const retryAfterMs = typeof body.retry_after_ms === 'number'
        ? body.retry_after_ms
        : retryHeader && !Number.isNaN(Number(retryHeader))
            ? Number(retryHeader) * 1000
            : undefined;
    const reason = typeof body.details?.reason === 'string' ? body.details.reason : undefined;
    const code = errcode === CALL_FULL_ERRCODE || reason === CALL_FULL_REASON ? 'call_full' : codeForStatus(response.status);
    return new RtcError(code, `${context} failed with HTTP ${response.status}`, {
        status: response.status,
        retryAfterMs,
        matrixErrcode: errcode,
        reason,
    });
};
export const networkError = (context, cause) => new RtcError('network', `${context} failed: network error`, { cause });
